import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

export function useCheckWorkspaceMutation(options = {}) {
  return useMutation((dto) => {
    return http.post(HTTP_ENDPOINTS.postCheckWorkspace(), {
      sms_code: dto.code,
      workspace_id: dto.workspaceId,
    });
  }, options);
}
